export const allowClick = "text-blue-500 cursor-pointer";
export const notAllowClick = "text-[#d0d0d0] cursor-not-allowed";
